import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { Models } from '@ibexfusion/models';
import { EnvironmentService } from '@services/environment/environment.service';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-pipe-import-detail',
    templateUrl: './pipe-import-detail.component.html',
    styleUrls: ['./pipe-import-detail.component.scss'],
    providers: [PipeImportService],
    standalone: false
})
export class PipeImportDetailComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  isLoading = false;

  pipeImportId: string;

  title = 'Create new Pipe Importer';

  pipeImport: Models.PipeImport;

  create = false;
  contentTableJson: any = {};
  uploadedFiles: any[];

  public pageActions: PageAction[];

  constructor(
    private activatedRoute: ActivatedRoute, private pipeImportService: PipeImportService, private router: Router, private environmentService: EnvironmentService,
    private http: HttpClient
  ) {
  }

  async ngOnInit() {
    this.createPageActions();
    if (this.activatedRoute.snapshot.params['id']) {
      this.pipeImportId = this.activatedRoute.snapshot.params['id'];
      this.pipeImport = await this.pipeImportService.get(this.pipeImportId)
      this.title = this.pipeImport.title;
      this.contentTableJson = {
        id: this.pipeImport._id, autoUpdate: this.pipeImport.autoUpdate,
        autoUpdateInterval: this.pipeImport.autoUpdateInterval, executableByUser: this.pipeImport.executableByUser
      };
      this.pipeImport.modules.forEach(module => {
        if (module.group === 'Target' && module.module === 'Redis') {
          this.contentTableJson.redisLink = this.environmentService.getPipeBackendUrl() + 'getCachedResult/' + this.pipeImport._id
        }
        if (module.group === 'Request' && module.module === 'Upload') {
          this.initUploadedFiles();
        }
      });
      this.isLoading = false;
    }
  }

  private async initUploadedFiles() {
    return this.http.post(this.environmentService.getPipeBackendUrl() + 'getUploadedFiles/', { pipeId: this.pipeImport._id }).toPromise().then((result: any) => {
      if (!result?.length) {
        return;
      }
      this.uploadedFiles = result.sort((a, b) => new Date(b.LastModified).getTime() - new Date(a.LastModified).getTime());
      this.uploadedFiles = this.uploadedFiles.slice(0, 10);
    }).catch(err => {
      console.error(err);
    });
  }

  getFileName(file) {
    return file.Key.split('/')[file.Key.split('/').length - 1];
  }

  async downloadFile(file): Promise<any> {
    try {
      const result: any = await this.http.post(this.environmentService.getPipeBackendUrl() + 'getSignedUrl/', { key: file.Key }).toPromise();
      const a = Object.assign(document.createElement('a'), { href: result.url });
      a.click();
      a.remove();
    } catch (err) {
      console.error(err);
    }
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'Edit Pipe',
        callback: () => {
          this.router.navigate(['pipe-imports', this.pipeImportId, 'edit']);
        }
      }),
      new PageAction({
        icon: 'rowing',
        title: 'Execute',
        callback: () => {
          this.pipeImportService.patch(this.pipeImportId, <any>{ forcedExecution: true });
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'Logs',
        callback: () => {
          this.router.navigate(['pipe-imports/', this.pipeImportId, 'logs']);
        }
      })
    ];
  }
}
